import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordMatchValidator(
  password: string,
  confirmPassword: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const passwordValue = control.get(password)?.value;
    const confirmPasswordValue = control.get(confirmPassword)?.value;

    if (passwordValue !== confirmPasswordValue) {
      control.get(confirmPassword)?.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    } else {
      control.get(confirmPassword)?.setErrors(null);
      return null;
    }
  };
}

export function matchPasswordValidator(passwordField: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) {
      return null;
    }
    const password = control.parent.get(passwordField)?.value;
    const confirmPassword = control.value;

    return password === confirmPassword ? null : { matchPassword: false };
  };
}
